import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Outlet } from "react-router-dom";

export default withAuthenticationRequired(Outlet);
